var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3366 2.00001H19.1415C18.8135 1.99908 18.4886 2.06325 18.1856 2.18882C17.8826 2.31439 17.6076 2.49886 17.3764 2.73152L10.2801 9.8228C8.9426 9.36589 7.48979 9.37532 6.15832 9.84955C4.82685 10.3238 3.69519 11.2349 2.94766 12.4344C2.20013 13.6339 1.88078 15.0513 2.04164 16.4555C2.20249 17.8597 2.83407 19.1681 3.83349 20.1675C4.83292 21.1669 6.1413 21.7985 7.54551 21.9593C8.94973 22.1202 10.367 21.8008 11.5666 21.0533C12.7661 20.3058 13.6772 19.1741 14.1514 17.8427C14.6257 16.5112 14.6351 15.0584 14.1782 13.7209L16.1755 11.7236V8.6577H18.6721V6.16107H21.6273C21.8703 5.77031 21.9997 5.31962 22.001 4.85949V3.66443C22.001 3.223 21.8256 2.79965 21.5135 2.48751C21.2013 2.17537 20.778 2.00001 20.3366 2.00001ZM6.60506 18.6442C6.35817 18.6442 6.11682 18.571 5.91153 18.4339C5.70625 18.2967 5.54625 18.1017 5.45177 17.8736C5.35728 17.6455 5.33256 17.3945 5.38073 17.1524C5.4289 16.9102 5.54779 16.6878 5.72237 16.5132C5.89695 16.3386 6.11938 16.2198 6.36153 16.1716C6.60368 16.1234 6.85467 16.1481 7.08277 16.2426C7.31087 16.3371 7.50583 16.4971 7.643 16.7024C7.78017 16.9077 7.85338 17.149 7.85338 17.3959C7.85338 17.727 7.72186 18.0445 7.48775 18.2786C7.25365 18.5127 6.93614 18.6442 6.60506 18.6442Z",
    fill: "#101828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.c93f5dd8a1fe1ede744a10f1cbbfa73c.svg";
export { ForwardRef as ReactComponent };